import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { MapLine } from "../interfaces/map-line";

export const lineStringControl = (color?: string) => {
    const colorLineString = color ?? '#00ac11';

    const mapDrawer = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
            line_string: true,
            trash: true
        },
        styles: [
            {
                "id": "gl-draw-line",
                "type": "line",
                "filter": ["all", ["==", "$type", "LineString"], ["!=", "mode", "static"]],
                "layout": {
                    "line-cap": "round",
                    "line-join": "round"
                },
                "paint": {
                    "line-color": colorLineString,
                    "line-dasharray": [0.2, 2],
                    "line-width": 6,
                    "line-opacity": 0.8
                }
            },
            {
                "id": "gl-draw-polygon-and-line-vertex-active",
                "type": "circle",
                "filter": ["all", ["==", "meta", "vertex"],
                    ["==", "$type", "Point"],
                    ["!=", "mode", "static"]
                ],
                "paint": {
                    "circle-radius": 9,
                    "circle-color": colorLineString
                }
            }
        ]
    });


    return mapDrawer;
}

export const drawLineString = (lineStringDrawer: MapboxDraw, line: MapLine) => {
    const coordinates = line.coordinates.map(x => x.coordinate);
    const feature = {
        type: 'FeatureCollection',
        features: [{
            type: 'Feature',
            properties: {},
            id: line.identification,
            geometry: {
                type: 'LineString',
                coordinates: coordinates
            }
        }]
    }
    lineStringDrawer.add(feature);
}
